import {
  SET_TRACKED_LIST,
} from './track.constant';

/* Actions */
import { setTrackedList } from "./track.action";

const initialState: TrackState = { list: [] };

type TrackAction = ReturnType<typeof setTrackedList>;

export function trackReducer(
  state = initialState,
  action: TrackAction
): TrackState {
  switch (action.type) {
    case SET_TRACKED_LIST:
      return { ...state, list: action.payload };
    default:
      return state;
  }
}